<template>
  <div class="h-100 d-flex justify-center align-center">
    <AppCard class="w-50">
      <v-row>
        <v-col class="text-center">
          <h1>{{ $t('payment.PaymentCancel.title') }}</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center">
          <app-material-icon name="close" :size="100" color="error" />
        </v-col>
      </v-row>
    </AppCard>
  </div>
</template>

<script>
import AppCard from '@/common/AppCard.vue'

export default {
  name: 'PaymentCancel',
  components: { AppCard },
}
</script>
